import { updateTextQtdIconMobile } from './carrinho.js';
import { reloadicons } from './svg.js';
import { closeNav, openNav } from './utilities.js';

$(document).ready(function () {
	updateTextQtdIconMobile();

	// const shareButton = document.getElementsByClassName("iconshare"); 
	// shareButton.addEventListener("click", (e) => { 
	// 	if (navigator.share) {
	// 		navigator.share({
	// 			title: shareButton[0].getAttribute('title'),
	// 			text: shareButton[0].getAttribute('text'),
	// 			url: shareButton[0].getAttribute('url'),
	// 		})
	// 		.then(() => console.log('Successful share'))
	// 		.catch((error) => console.log('Error sharing', error));
	// 	} else {
	// 		console.log('Share not supported on this browser, do it the old way.');
	// 	}
	// });


	$(document).on("click touchend", ".nav-footer h4", function (e) {
		e.preventDefault();
		var aberto = $(this).find(".setacima");
		var fechado = $(this).find(".setabaixo");
		var conteudo = $(this).parent().find("ul, div");
		if (fechado.length == 1) {
			fechado.removeClass("setabaixo");
			fechado.addClass("setacima");
			conteudo.css("display", "flex");
			reloadicons("setacima");
		}
		if (aberto.length == 1) {
			aberto.removeClass("setacima");
			aberto.addClass("setabaixo");
			conteudo.css("display", "none");
			reloadicons("setabaixo");
		}
	});
	$(document).on("click touchend", "#mobile-headerLine ul li a.navbar-toggle, #mobile-headerLine ul li.search-open", function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		const isMobile = $(window).width() <= 991;

		if(isMobile) {
			$(`.dropdown.menu-user-dropdown`).addClass("active");
			$('#overlay-geral').addClass("active");
			$("html").css("overflow", "hidden")
			$('#mobile-navbar li.list[data-dropdown="menu-user-dropdown"]').first().addClass("active");
		} else {
			if ($(this).hasClass("collapsed")) {
				closeAllMenus();
				openNavMobile();
				// $(this).removeClass("collapsed");
			} else {
				closeNavMobile();
				// $(this).addClass("collapsed")
			}
		}

	});

	$(document).on("click touchend", "#mobile-headerLine ul li a.mobile-loginIcon", function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		const isMobile = $(window).width() <= 991;

		if(isMobile) {
			$(`.dropdown.menu-login-dropdown`).addClass("active");
			$('#overlay-geral').addClass("active");
			$("html").css("overflow", "hidden")
			$('#mobile-navbar li.list[data-dropdown="menu-login-dropdown"]').addClass("active");
		}else {
			if ($(this).hasClass("collapsed")) {
				closeAllMenus();
				openNavUserMobile();
				// $(this).removeClass("collapsed");
			} else {
				closeNavUserMobile();
				// $(this).addClass("collapsed")
			}
		}
	});

	$(document).on("click touchend", ".category-sub-menu .filters-toggle, .category-filters-lateral .iconclose", function (e) {
		e.preventDefault();
		if ($(".category-sub-menu .category-filters-lateral").hasClass("collapsed")) {
			closeAllMenus();
			openFilterMobile();
		} else {
			closeFilterMobile();
		}
	});
	// Menu institucional
	$(document).on("click touchend", ".menu-suporte .menuInst-toggle, .category-menuInst-lateral .iconclose", function (e) {
		e.preventDefault();
		if ($(".menu-suporte .category-menuInst-lateral").hasClass("collapsed")) {
			closeAllMenus();
			openMenuInstMobile();
		} else {
			closeMenuInstMobile();
		}
	});
	$(document).on("click touchend", ".category-sub-menu .orders-toggle, .category-orderby-lateral .iconclose", function (e) {
		e.preventDefault();
		if ($(".category-sub-menu .category-orderby-lateral").hasClass("collapsed")) {
			closeAllMenus();
			openOrderbyMobile();
		} else {
			closeOrderbyMobile();
		}
	});

	$(document).on("click", "#mobileMenu .mm-next", function (e) {
		e.preventDefault();
		var atual = $(this).attr("data-mmatual");
		var pai = $(this).attr("data-mmpai");
		var filho = $(this).attr("data-mmfilho");
		$("#mobileMenu #" + atual).removeClass("mm-opened");
		$("#mobileMenu #" + atual).addClass("mm-waiting");
		$("#mobileMenu #" + atual).one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function (event) {
			$("#mobileMenu #" + atual).addClass("mm-hidden");
			$("#mobileMenu #" + atual).off("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend");
		});
		$("#mobileMenu #" + filho).removeClass("mm-hidden");
		var maxTime = 1000, startTime = Date.now();
		var interval = setInterval(function () {
			if ($("#mobileMenu #" + filho).is(':visible')) {
				$("#mobileMenu #" + filho).addClass("mm-opened");
				clearInterval(interval);
			} else {
				if (Date.now() - startTime > maxTime) {
					$("#mobileMenu #" + filho).addClass("mm-opened");
					clearInterval(interval);
				}
			}
		},
			100
		);
	});

	$(document).on("click", "#mobileMenu .mm-prev", function (e) {
		e.preventDefault();
		var atual = $(this).attr("data-mmatual");
		var pai = $(this).attr("data-mmpai");
		$("#mobileMenu #" + atual).removeClass("mm-opened");
		$("#mobileMenu #" + atual).one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function (event) {
			$("#mobileMenu #" + atual).addClass("mm-hidden");
			$("#mobileMenu #" + atual).off("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend");
		});
		$("#mobileMenu #" + pai).removeClass("mm-hidden");
		var maxTime = 1000, startTime = Date.now();
		var interval = setInterval(function () {
			if ($("#mobileMenu #" + pai).is(':visible')) {
				$("#mobileMenu #" + pai).addClass("mm-opened");
				$("#mobileMenu #" + pai).removeClass("mm-waiting");
				clearInterval(interval);
			} else {
				if (Date.now() - startTime > maxTime) {
					$("#mobileMenu #" + pai).addClass("mm-opened");
					$("#mobileMenu #" + pai).removeClass("mm-waiting");
					clearInterval(interval);
				}
			}
		},
			100
		);
	});

	// $(document).on("click", "#mobile-headerLine .search-open, #mobile-navbar .search-open", function () {
	// 	$("#mobile-headerSearch").removeClass("d-none");
	// 	$("#form-search").children().focus();
	// });

	// $('#mobile-headerSearch .search-close').on("click", function (e) {
	// 	e.stopPropagation();
	// 	e.preventDefault();
	// 	$("#mobile-headerSearch").addClass("d-none");
	// });

	$("#mobile-headerLine .btn-cart").on("click", function (e) {
		e.stopPropagation();
		e.preventDefault();

		openNav();
	});
});

/* mobileMenu */
export function openNavMobile() {
	$("#mobileMenu").addClass("mobilemenu-aberto");
	$("#main-content").addClass("mobilemenu-aberto");
	$("body").addClass("aberto");
	if ($("#mobile-headerLine ul li a.navbar-toggle").hasClass("collapsed")) {
		$("#mobile-headerLine ul li a.navbar-toggle").removeClass("collapsed");
	}
	$("#overlay-geral").addClass("active");
	$("html").css("overflow", "hidden")
}

export function closeNavMobile() {
	$("#mobileMenu").removeClass("mobilemenu-aberto");
	$("#main-content").removeClass("mobilemenu-aberto");
	$("body").removeClass("aberto");
	if (!$("#mobile-headerLine ul li a.navbar-toggle").hasClass("collapsed")) {
		$("#mobile-headerLine ul li a.navbar-toggle").addClass("collapsed");
	}
	$("#mobileMenu .mm-panel").addClass("mm-hidden");
	$("#mobileMenu .mm-panel").removeClass("mm-waiting");
	$("#mobileMenu #mm-0").removeClass("mm-hidden");
	$("#mobileMenu #mm-0").addClass("mm-opened");
	$("#overlay-geral").removeClass("active");
	$("html").css("overflow", "auto")
}

export function openNavUserMobile() {
	$("#mobileUserMenu").addClass("mobileusermenu-aberto");
	$("#main-content").addClass("mobilemenu-aberto");
	$("body").addClass("aberto");
	if ($("#mobile-headerLine ul li a.mobile-loginIcon").hasClass("collapsed")) {
		$("#mobile-headerLine ul li a.mobile-loginIcon").removeClass("collapsed");
	}
	$("#overlay-geral").addClass("active");
	$("html").css("overflow", "hidden")
}

export function closeNavUserMobile() {
	$("#mobileUserMenu").removeClass("mobileusermenu-aberto");
	$("#main-content").removeClass("mobilemenu-aberto");
	$("body").removeClass("aberto");
	if (!$("#mobile-headerLine ul li a.mobile-loginIcon").hasClass("collapsed")) {
		$("#mobile-headerLine ul li a.mobile-loginIcon").addClass("collapsed");
	}
	$("#overlay-geral").removeClass("active");
	$("html").css("overflow", "auto")
}


export function openFilterMobile() {
	$(".category-sub-menu .category-filters-lateral").removeClass("collapsed");
	$("#main-content").addClass("mobilemenu-aberto");
	$("body").addClass("aberto");
	$("#overlay-geral").addClass("active");
	$("html").css("overflow", "hidden")
}
/* Menu Institucional */
export function openMenuInstMobile() {
	$(".menu-suporte .category-menuInst-lateral").removeClass("collapsed");
	$("#main-content").addClass("mobilemenu-aberto");
	$("body").addClass("aberto");
	$("#overlay-geral").addClass("active");
	$("html").css("overflow", "hidden")
}
/* Menu Institucional */

export function closeFilterMobile() {
	$("#main-content").removeClass("mobilemenu-aberto");
	$("body").removeClass("aberto");
	if (!$(".category-sub-menu .category-filters-lateral").hasClass("collapsed")) {
		$(".category-sub-menu .category-filters-lateral").addClass("collapsed");
	}
	$("#overlay-geral").removeClass("active");
	$("html").css("overflow", "auto")
}
/* Menu Institucional */
export function closeMenuInstMobile() {
	$("#main-content").removeClass("mobilemenu-aberto");
	$("body").removeClass("aberto");
	if (!$(".menu-suporte .category-menuInst-lateral").hasClass("collapsed")) {
		$(".menu-suporte .category-menuInst-lateral").addClass("collapsed");
	}
	$("#overlay-geral").removeClass("active");
	$("html").css("overflow", "auto")
}
/* Menu Institucional */
export function openOrderbyMobile() {
	$(".category-sub-menu .category-orderby-lateral").removeClass("collapsed");
	$("#main-content").addClass("mobilemenu-aberto");
	$("body").addClass("aberto");
	$("#overlay-geral").addClass("active");
	$("html").css("overflow", "hidden")
}

export function closeOrderbyMobile() {
	$("#main-content").removeClass("mobilemenu-aberto");
	$("body").removeClass("aberto");
	if (!$(".category-sub-menu .category-orderby-lateral").hasClass("collapsed")) {
		$(".category-sub-menu .category-orderby-lateral").addClass("collapsed");
	}
	$("#overlay-geral").removeClass("active");
	$("html").css("overflow", "auto")
}

export function closeAllMenus() {
	closeNav();
	closeNavMobile();
	closeNavUserMobile();
	closeFilterMobile();
	closeOrderbyMobile();
	closeMenuInstMobile();
	$("html").css("overflow", "auto")
}
// Barra mobile: encolhe rolando para baixo; volta rolando para cima, perto do topo ou ao tocar nela
(function () {
	var barra = document.getElementById("mobile-navbar");
	if (!barra) return;
	var ultimo = window.scrollY, pedido = false;
	window.addEventListener("scroll", function () {
		if (pedido) return;
		pedido = true;
		requestAnimationFrame(function () {
			pedido = false;
			var y = window.scrollY;
			if (y < 24 || barra.querySelector("li.active")) barra.classList.remove("compacta");
			else if (y - ultimo > 8) barra.classList.add("compacta");
			else if (ultimo - y > 8) barra.classList.remove("compacta");
			if (Math.abs(y - ultimo) > 8 || y < 24) ultimo = y;
		});
	}, { passive: true });
	barra.addEventListener("click", function () {
		barra.classList.remove("compacta");
	}, true);
})();

// Mini banners do celular: a altura acompanha o banner da vez (os banners tem tamanhos diferentes)
$(window).on("load", function () {
	$(".banner-central-mini-carousel.mobile.slick-initialized").slick("slickSetOption", "adaptiveHeight", true, true);
});
// ... e mede de novo quando cada imagem termina de carregar (no iPhone media antes e cortava o banner)
document.querySelectorAll(".banner-central-mini-carousel.mobile").forEach(function (carrossel) {
	carrossel.addEventListener("load", function (e) {
		if (e.target.tagName === "IMG" && $(carrossel).hasClass("slick-initialized")) {
			$(carrossel).slick("setPosition");
		}
	}, true);
});
